var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:{'darkFooter': _vm.dark, 'staticFooter': _vm.isStatic}},[_c('div',{staticClass:"footMain"},[_c('div',{staticClass:"footTxt"},[_vm._v(_vm._s(_vm.copyright))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4af9ed4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/infoFooter.vue
// module id = null
// module chunks = 